<!--
 * @Description: 我的运单
 * @Author: ganjia
 * @Date: 2019-10-11 10:09:33
 -->
<template>
  <div class="main-wrap order">
    <div class="order-top">
      <div class="search-btns">
        <el-form :inline="true">
          <!-- 隐藏合单功能 -->
          <!-- <el-form-item v-if="exportStatus === 'wait_print'">
              <el-button type="primary" :loading="mergeLoading" :disabled="multipleSelection.length > 1 &&(exportStatus === 'all' || exportStatus === 'wait_print')? false: true"
              @click="mergeOrder" class="h40" icon="iconfont iconhedan">{{$lang('合单')}}</el-button>
          </el-form-item> -->
          <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
            <print ref="printOrder" :typeName="'oneAndtwoLinkPage'" :getPrintData="getPrintData" :options="printOptions" :hasPower="true" :isDisabled="!hasEdit"></print>
          </el-form-item>
          <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
            <el-button type="primary" class="h40" @click="batchCancelOrder" :disabled="!hasEdit" icon="iconfont iconshanchu">{{ $lang('批量取消') }}</el-button>
          </el-form-item>
          <!--  <el-form-item v-if="exportStatus === 'already_cancle'">
            <el-button type="primary" class="h40" @click="batchDelOrder" :disabled="!hasEdit" icon="iconfont iconshanchu">{{ $lang('批量删除') }}</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button icon="iconfont icondaochu" type="primary" @click="exportOpen" :loading="exportLoading" class="h40" plain>{{ $lang('导出') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="order-topLeft" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker :clearable="false" v-model="searchParam.date" type="datetimerange" :range-separator="$lang('至')" :start-placeholder="$lang('开始时间')" :end-placeholder="$lang('结束时间')"
                            class="commonSize" @change="selectDate" :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item prop="ids">
            <!-- <el-input v-model="searchParam.ids[0]" placeholder="请输入订单编号"></el-input> -->
            <base-input-tag
              style="width:220px"
              v-model="searchParam.ids"
              :placeholder="$lang('请输入订单编号(最多可查200条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="waybillIds">
            <!-- <el-input v-model="searchParam.waybillIds[0]" placeholder="请输入运单编号"></el-input> -->
            <base-input-tag
              style="width:210px"
              v-model="searchParam.waybillIds"
              :placeholder="$lang('请输入运单编号(最多可查200条)')"
              :clearBtnVisible="true"
              ref="BaseInputTag2"
              :addTagOnBlur="true"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="receiverMobilePhone">
            <el-input v-model="searchParam.receiverMobilePhone" :placeholder="$lang('请输入收件人联系电话')" maxlength='15'></el-input>
          </el-form-item>
          <!-- <el-form-item prop="customerOrderId">
            <el-input v-model="searchParam.customerOrderIds[0]" :placeholder="$lang('客户订单号')"></el-input>
          </el-form-item> -->
          <el-form-item prop="customerOrderIds">
            <base-input-tag
              style="width:230px"
              v-model="searchParam.customerOrderIds"
              :placeholder="$lang('请输入客户订单号(最多可查200条)')"
              :clearBtnVisible="true"
              ref="BaseInputTag3"
              :addTagOnBlur="true"
              validate="isSymbolNumberLetter"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="expressTypeCodeList" class="expressTypeCodeList-input">
            <el-select v-model="searchParam.expressTypeCodeList" multiple collapse-tags :placeholder="$lang('请选择快递类型')" :clearable="true" filterable class="vipsBox">
              <el-option
                v-for="item in productTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
           <el-form-item prop="isVipSource" >
          <el-select v-model="searchParam.isVipSource"  :placeholder="$lang('请选择订单来源')" :clearable="true" filterable class="vipsBox">
            <el-option
              v-for="item in isVipList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="createBy" >
          <el-select v-model="searchParam.createBy" :placeholder="$lang('请选择子账号')" :clearable="true" filterable class="vipsBox">
            <el-option
              v-for="item in findChildAccountList"
              :key="item.id"
              :label="item.account"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="thirdPartyWaybillIds">
          <base-input-tag
            style="width:230px"
            v-model="searchParam.thirdPartyWaybillIds"
            :placeholder="$lang('请输入三方运单号(最多可查200条)')"
            :clearBtnVisible="true"
            ref="BaseInputTag4"
            :addTagOnBlur="true"
            class="cms-input-tag">
          </base-input-tag>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32">{{ $lang('查询') }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{ $lang('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="order-bottom">
      <div class="tabs-nav">
        <div class="tabs-nav-item" v-for="(item,index) in menuItems" :key="index" @click="changeTab(index, item.orderStatusCode)" :class="{ active: tabActive === item.orderStatusCode }">
          {{ item.orderStatusName }}<span class="tabs-nav-item-count">{{ item.total }}</span>
        </div>
      </div>
      <JmsTableScroll ref="table" :option="listOpt" :data="tableList" :page="page" :table-loading="loading" @size-change="sizeChange" :isCheckedAll="isCheckedAll"
                      @select-all="handleSelectAll1"
                      @select="handleSelectionChange"
                      @current-change="currentChange"
                      :summaryMethod="summaryMethod">
        <template slot="orderStatusName" slot-scope="data">
          <span class="dot" :class="data.row.orderStatusName=='待打印' || data.row.orderStatusName === 'Unprinted' ?'oragin':''" v-show="data.row.orderStatusName=='待打印' || data.row.orderStatusName === 'Unprinted'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" :class="data.row.orderStatusName=='已打印' || data.row.orderStatusName === 'Printed' ?'oragin':''" v-show="data.row.orderStatusName=='已打印' || data.row.orderStatusName === 'Printed'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" :class="data.row.orderStatusName=='已取件' || data.row.orderStatusName === 'Picked up' ?'green':''" v-show="data.row.orderStatusName=='已取件' || data.row.orderStatusName === 'Picked up'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" v-show="data.row.orderStatusName=='已取消' || data.row.orderStatusName === 'Cancelled'">{{ $lang(data.row.orderStatusName) }}</span>
        </template>
        <template slot="waybillId" slot-scope="data">

          <!-- <div @click="getExpressTracking(data.row.waybillId)" class="getExpressTracking">
             <span>{{data.row.waybillId}}</span>
          </div> -->
          <el-tooltip placement="top">
            <div slot="content" @click="handleCopy(data)" style="cursor:pointer">{{ $lang('复制运单号') }}</div>
            <span @click="getExpressTracking(data.row.waybillId)" class="getExpressTracking">{{ data.row.waybillId }}</span>
          </el-tooltip>
        </template>
        <template #customerPickInfo="{ row }">
          <div v-if="row.orderSourceCode === 'D21'">
            <span v-if="row.goodsJson && row.goodsJson.length === 1">{{ row.goodsJson[0].name + row.goodsJson[0].quantity + row.goodsJson[0].sku }}</span>
            <span v-if="row.goodsJson && row.goodsJson.length > 1" style="color: #2d7cff;cursor: pointer;" @click="goodsJsonClick(row.goodsJson)">{{ $lang('查看') }}</span>
            <span v-if="!row.goodsJson || !row.goodsJson.length">--</span>
          </div>
          <span v-else>{{ row.customerPickInfo }}</span>
        </template>
        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text">{{ $lang('查看') }}</el-button>
            <!-- 编辑按钮 -->
            <el-button v-show="showEdit(data.row)" @click="rowEdit(data.row)" type="text">{{ $lang('编辑') }}</el-button>
            <!-- <el-button v-show="data.row.orderStatusName=='待打印'||data.row.orderStatusName=='已打印'" @click="rowEdit(data.row)" type="text" icon="iconfont iconbianji font-16"></el-button> -->
            <!-- 取消按钮 -->
            <el-button v-show="permissionBut('CANCEL', data.row) && showCancel(data.row)" @click="cancelFn(data.row)" type="text">{{ $lang('取消') }}
            </el-button>
            <!-- 删除按钮 -->
            <!-- <el-button v-show="data.row.orderStatusName=='已取消'" @click="rowDel({'orderId':data.row.id})" type="text">{{ $lang('删除') }}</el-button> -->
          </div>
        </template>
        <!-- <template slot="remarks" slot-scope="data">
          <el-tooltip placement="top">
            <div slot="content" style="width:500px; overflow-x:auto; cursor:pointer">{{ data.row.remarks }}</div>
            <div class="remark-style">{{data.row.remarks}}</div>
          </el-tooltip>
        </template> -->
      </JmsTableScroll>
    </div>

    <!-- 编辑订单弹框组件 -->
    <merge-order ref="mergeOrder" :mergeVisible='isShowMerge' :mergeList="mergeList" @closeMerge="closeMerge"></merge-order>
    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet" :viewDialogVisible='viewDialogVisible' @closeDetails='closeDetails' :bulletTitle='1' :rowData='rowData'></bullet>
    <!-- 取消订单弹框组件 -->
    <cancel-order :selectId="selectId" ref="cancelOrder" @cancelSuccess="cancelSuccess"></cancel-order>
    <!-- 编辑订单弹框组件 -->
    <edit-order ref="editOrder" :orderData="rowData" v-model="editDialogVisible" @editSave="editSave" @editClose="editClose"></edit-order>
    <!-- 导出订单弹框组件 -->
    <!-- <export-componet ref="exportComponet" :cityOptions="orderOptions" :idsLength="multipleSelection.length" :exportVisible="exportVisible"
                     :exportData="exportData" @export-close="exportClose" @export-fn="exportFn"></export-componet> -->

    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
    <el-dialog :title="$lang('拣货信息明细')" :visible.sync="goodsJsonShow" width="600px" :close-on-press-escape="false" :close-on-click-modal="false">
      <div style="padding-bottom: 20px;">
        <el-table :data="goodsJsonList" border style="width: 100%" :max-height="300">
          <el-table-column type="index" align="center" :label="$lang('序号')" width="80"/>
          <el-table-column prop="name" align="center" :label="$lang('物品名称')"/>
          <el-table-column prop="quantity" align="center" :label="$lang('件数')"/>
          <el-table-column prop="sku" align="center" label="SKU"/>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import { orderList, asyExportOrder, orderrDelete, orderTotalGroup, detailOrder, orderUpdate, printOrders, UserDetail, orderBatchDelete, findChildAccount, getExpressType } from '@api/module/customer'
import bullet from '@components/base/BaseBullet.vue'
import cancelOrder from './components/CancelOrder.vue'
import mergeOrder from './components/MergeOrder.vue'
import editOrder from './components/WebEditOrder.vue'
import { commonFun } from '@utils/common'
import { RESPONSE_SUCCESS } from '@constants'
import Print from '@components/jms-widget/print'
import { mapActions, mapGetters } from 'vuex'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'

export default {
  name: 'Order',
  mixins: [mixin],
  components: {
    JmsTableScroll,
    bullet,
    cancelOrder,
    editOrder,
    // exportComponet,
    mergeOrder,
    Print,
    ExportDownloadDialog,
  },
  data() {
    const _this = this
    return {
      // showTooltip: false,
      pickerOptions: {
        disabledDate(time) {
          const space = 180 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = _this.$dayjs(new Date().getTime()).format('YYYY-MM-DD') + ' 23:59:59'
          return time.getTime() < minTime || time.getTime() > maxTime
        },
      },
      COM_HTTP: {
        reqList: orderList,
        // reqExcel: regularOutputExcel,
        reqExcel: asyExportOrder,
        reqDel: orderrDelete,
        reqDetail: detailOrder,
        reqUpdate: orderUpdate,
      },
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        ids: [], // 订单号
        receiverMobilePhone: '', // 手机号
        tabTypeCode: 'wait_print', // 页签（all，wait_pick，already_pick，already_cancle）
        waybillIds: [],
        isVipSource: '',
        createBy: '',
        customerOrderIds: [],
        expressTypeCodeList: [],
        thirdPartyWaybillIds: [], // 三方运单号
      },
      menuItems: [], // tab菜单
      activeIndex: '1', // tab 选中
      multipleSelection: [], // 多选或全选数据
      disabled: true, // 禁止点击状态
      exportVisible: false, // 导出弹框显示
      excelParams: {}, // 导出日期条件
      exportStatus: 'wait_print', // 默认状态
      exportType: 1, // 1：订单； 2：运单
      exportData: {},
      orderOptions: [],
      selectId: '', // 当前选中的id
      mergeLoading: false, // 合并loading
      printLoading: false, // 打印按钮loading
      exportLoading: false, // 导出loading
      printTableVisible: false, // 子订单打印
      isShowMerge: false, // 合并
      mergeList: [], // 合并数据
      printOptions: {
        btnTitle: this.$lang('面单打印'),
        btnType: 'primary',
        addClass: 'h40',
      },
      isVipList: [{ name: this.$lang('VIP'), lable: 1, code: 1 }, { name: this.$lang('非VIP'), lable: 2, code: 2 }],
      isCheckedAll: false,
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      tabActive: 'wait_print',
      isKeyUp: false,
      autoPrint: false,
      dialogExportDownVisible: false, // 下载中心
      moduleType: 'my_order_qy', // 我的订单
      hasEdit: true,
      findChildAccountList: [],
      productTypeList: [], // 产品类型
      goodsJsonList: [], // 拣货信息list
      goodsJsonShow: false // 拣货信息明细弹框
    }
  },
  async created() {
    this.init()
  },
  computed: {
    ...mapGetters([
      'viewAllData',
      'operationAllData'
    ]),
    listOpt() {
      const _this = this
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        rowKey: '$index',
        fixHeight: 90,
        showTooltip: false,
        menuWidth: 150,
        dynamicOptions: {
          getUrl: '/vip/configuration/queryOrderConfiguration',
          defaultUrl: '/vip/configuration/saveOrUpdateOrderConfiguration',
          saveUrl: '/vip/configuration/saveOrUpdateOrderConfiguration',
        },
        selectable: (row, index) => {
          return _this.permission('CANCEL', row)
        },
        // menuWidth: 150,
        //  搜索框和表格列及其字段
        showSummary: this.tabActive === 'already_print' || this.tabActive === 'already_pick',
        column: [
          {
            label: this.$lang('订单编号'),
            prop: 'id',
          },
          {
            label: this.$lang('运单编号'),
            prop: 'waybillId',
            slot: true,
            width: 150,
          },
          {
            label: this.$lang('状态'),
            prop: 'orderStatusName',
            slot: true,
          },
          {
            label: this.$lang('订单来源'),
            prop: 'orderSourceName',
            formatter: (row, value, label, column) => {
              return row.orderSourceName === 'VIP' ? _this.$lang('VIP') : _this.$lang('非VIP')
            },
            width: 200,
          },
          {
            label: this.$lang('打印次数'),
            prop: 'printsNumber',
          },
          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderId',
            width: 150,
          },
          {
            label: this.$lang('寄件人地址'),
            prop: 'shipperAddress',
            formatter: (row, value, label, column) => {
              return `${row.senderName}/${row.senderMobilePhone}/${row.senderTelphone ? (row.senderTelphone + '/') : ''}${row.sendRoomNumber !== undefined && row.sendRoomNumber !== null ? (row.sendRoomNumber + '/') : ''}${row.sendFloor !== undefined && row.sendFloor !== null ? (row.sendFloor + '/') : ''}${row.sendBuildingNo !== undefined && row.sendBuildingNo !== null ? (row.sendBuildingNo + '/') : ''}${row.senderStreet !== undefined && row.senderStreet !== null ? (row.senderStreet + '/') : ''}${row.senderAreaName}/${row.senderCityName}/${row.senderProvinceName}`
            },
            width: 400,
          },
          // {
          //   label: this.$lang('寄件备注'),
          //   prop: 'sendRemark',
          // },
          {
            label: this.$lang('收件方'),
            prop: 'receiver',
            formatter: (row, value, label, column) => {
              return `${row.receiverName}/${row.receiverMobilePhone}/${row.receiverTelphone ? (row.receiverTelphone + '/') : ''}${row.receiverRoomNumber !== undefined && row.receiverRoomNumber !== null ? (row.receiverRoomNumber + '/') : ''}${row.receiverFloor !== undefined && row.receiverFloor !== null ? (row.receiverFloor + '/') : ''}${row.receiverBuildingNo}/${row.receiverStreet !== undefined && row.receiverStreet !== null ? (row.receiverStreet + '/') : ''}${row.receiverAreaName}/${row.receiverCityName}/${row.receiverProvinceName}`
            },
            width: 400,
          },
          // {
          //   label: this.$lang('派件备注'),
          //   prop: 'receiverRemark',
          // },
          {
            label: this.$lang('物品类型'),
            prop: 'goodsTypeName',
          },
          {
            label: this.$lang('是否调度'),
            prop: 'needDispatch',
            formatter(row) {
              return row.needDispatch === 1 ? '是' : '否'
            },
          },
          {
            label: this.$lang('物品名称'),
            prop: 'goodsName',
          },
          {
            label: this.$lang('物品重量'),
            prop: 'packageTotalWeight',
          },
          {
            label: this.$lang('客户拣货数量'),
            prop: 'customerPickNumber',
          },
          // {
          //   label: this.$lang('长/宽/高'),
          //   prop: 'machine',
          //   formatter: (row, value, label, column) => {
          //     return `${row.packageLength !== undefined && row.packageLength !== null ? (row.packageLength + '/') : ''}${row.packageWide !== undefined && row.packageWide !== null ? (row.packageWide + '/') : ''}${row.packageHigh !== undefined && row.packageHigh !== null ? row.packageHigh : ''}`
          //   },
          //   width: 100,
          // },
          // {
          //   label: this.$lang('包裹数量'),
          //   prop: 'packageNumber',
          // },
          {
            label: this.$lang('快递类型'),
            prop: 'expressTypeName',
          },
          {
            label: this.$lang('保险价值'),
            prop: 'declaredValue',
          },
          {
            label: this.$lang('保价费'),
            prop: 'insuredValue',
          },
          {
            label: this.$lang('结算方式'),
            prop: 'paymentModeName',
          },
          {
            label: this.$lang('支付方式'),
            prop: 'paidModeName',
          },
          // {
          //   label: this.$lang('平台'),
          //   prop: 'platformName',
          // },
          // {
          //   label: this.$lang('客户账号'),
          //   prop: 'customerAccount',
          // },
          {
            label: this.$lang('代收货款金额'),
            prop: 'codMoney',
            width: 100,
          },
          {
            label: this.$lang('代收货款手续费'),
            prop: 'codFee',
            width: 110,
          },
          {
            label: this.$lang('参考运费'),
            prop: 'standardValue',
            show: this.userInfo.freightStatus === 1,
          },
          // {
          //   label: this.$lang('客户拣货信息'),
          //   prop: 'customerPickInfo',
          // },
          {
            label: this.$lang('客户拣货信息'),
            slot: true,
            prop: 'customerPickInfo'
          },
          {
            label: this.$lang('备注'),
            prop: 'remarks',
            // slot: true,
            overHidden: false,
            width: 200,
          },
          // {
          //   label: this.$lang('下单账号'),
          //   prop: 'orderAccount',
          //   width: 150,
          // },
          {
            label: this.$lang('下单账户名称'),
            prop: 'orderAccount',
            width: 100,
          },
          {
            label: this.$lang('下单时间'),
            prop: 'inputTime',
            width: 150,
            show: this.exportStatus === 'all' || this.exportStatus === 'wait_pick',
          },
          {
            label: this.$lang('打印时间'),
            prop: 'printTime',
            width: 200,
          },
          {
            label: this.$lang('取消时间'),
            prop: 'cancelTime',
            width: 150,
            show: this.exportStatus === 'already_cancle',
          },
          {
            label: this.$lang('取件时间'),
            prop: 'pickTime',
            width: 150,
            show: this.exportStatus === 'already_pick',
          },
        ],
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
  },
  watch: {
    $route(newV, oldV) {
      if (oldV.name === 'home') {
        this.init()
      }
    },
    tableList: {
      handler(newVal, oldVal) {
        if (this.isKeyUp && this.exportStatus === 'wait_print' && this.tableList.length === 1 && this.autoPrint) {
          this.autoPrint = false
          this.multipleSelection = this.tableList
          this.$nextTick(() => {
            this.$refs.table.$refs.table.toggleRowSelection(this.tableList[0], true)
            this.$refs.printOrder && this.$refs.printOrder.openMenu()
          })
        }
      },
      deep: true,
    },
    multipleSelection: {
      handler(arr) {
        if (arr && arr.length) {
          this.hasEdit = arr.every(row => {
            return this.permission('CANCEL', row)
          })
        } else {
          this.hasEdit = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions(['LOGIN_OUT', 'SET_USER', 'UPDATE_PRINT_STOCK']),
    goodsJsonClick(arr) {
      this.goodsJsonList = arr
      this.goodsJsonShow = true
    },
    async init() {
      const homeQuery = JSON.parse(sessionStorage.getItem('homeQuery'))
      if (homeQuery) {
        this.tabActive = homeQuery.orderStatusCode
        this.searchParam.tabTypeCode = homeQuery.orderStatusCode
        this.searchParam.date = homeQuery.date
        this.searchParam.startdate = homeQuery.startTime
        this.searchParam.enddate = homeQuery.endTime
      }
      this.isSinleSelection = []
      this.getFindChildAccount()
      this.getUserInfo()
      this.getProductTypeList()
      const key = this.$route.params.typeNum
      // this.updateOutExcel(key)
      await this.orderTotalGroup(this.searchParam)
      if (key) {
        this.handleSelect(key)
      } else {
        this.searchFun()
      }
    },
    // 获取产品类型下拉列表
    async getProductTypeList() {
      const { code, data, msg } = await getExpressType()
      if (code === RESPONSE_SUCCESS) {
        this.productTypeList = data
      } else {
        this.$message.error(msg)
      }
    },
    showEdit(row) {
      const { orderStatusCode, expressTypeCode } = row
      return [100, 101, 102, 106].includes(orderStatusCode) && expressTypeCode !== 'RC' && expressTypeCode !== 'BC'
    },
    showCancel(row) {
      const { orderStatusCode, expressTypeCode } = row
      return [100, 101, 102, 106].includes(orderStatusCode) && expressTypeCode !== 'BC' && expressTypeCode !== 'RC'
    },
    permissionBut(type, row) {
      const { isSelf } = row
      const { operationAllData } = this
      const isMasterAcc = this.userInfo.parentId === 0
      if (type === 'EDIT') {
        return isSelf
      } else if (type === 'CANCEL') {
        return isMasterAcc && row.orderSourceName === 'VIP' || (!isMasterAcc && (operationAllData || isSelf)) && row.orderSourceName === 'VIP'
      }
    },
    permission(type, row) {
      const { isSelf } = row
      const { operationAllData } = this
      const isMasterAcc = this.userInfo.parentId === 0
      if (type === 'EDIT') {
        return isSelf
      } else if (type === 'CANCEL') {
        return isMasterAcc || (!isMasterAcc && (operationAllData || isSelf))
      }
    },
    /**
     * @description 复制
     */
    handleCopy(data) {
      const value = data.row.waybillId
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success',
      })
      oInput.remove()
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },

    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    toKeyUp() {
      if (this.isKeyUp) { // 回车搜索后首次输入清空输入框
        this.searchParam.customerOrderIds = []
        this.isKeyUp = false
      }
      return true
    },
    async payCode(e) {
      this.isKeyUp = true
      this.autoPrint = true
      this.searchFun(1)
      this.orderTotalGroup(this.searchParam)
    },
    // 获取打印数据
    async getPrintData(type, language) {
      const _this = this
      // let flag = false
      // for (let j = 0; j < this.multipleSelection.length; j++) {
      //   const element = this.multipleSelection[j]
      //   if (element.needDispatch === 1) {
      //     flag = true
      //     this.$message.error(this.$lang('调度单暂不支持面单打印'))
      //     break
      //   }
      // }
      // if (!flag) {
      const obj = this.multipleSelection.find(item => item.paymentModeName === '到付现结' && (!item.standardValue || item.standardValue === 0 || item.standardValue === '0'))
      if (obj) {
        this.$nextTick(() => {
          this.$message.warning(this.$lang('存在到付快件未维护费用，请联系网点维护'))
          this.multipleSelection = []
          this.isCheckedAll = false
          this.searchChange()
        })
        this.$refs['printOrder'].keyBtn = false
        return false
      }
      const result = this.multipleSelection.filter(item => item.expressTypeCode === 'RC').map(item => item.id)
      if (result && result.length > 0) {
        this.$nextTick(() => {
          const str = result.join(',')
          this.$message.warning(this.$lang(`${str}为回单不能打印`))
          this.multipleSelection = []
          this.isCheckedAll = false
          this.searchChange()
        })
        this.$refs['printOrder'].keyBtn = false
        return false
      }
      const newArr = this.multipleSelection.map((item, index, selection) => item.id)
      const hasCustomerOrderIds = this.multipleSelection.some(({ customerOrderId }) => !!customerOrderId)
      let isShowBarCode = ''
      if (type === 3 && hasCustomerOrderIds) {
        await this.$confirm(_this.$t('是否打印客户订单号条形码'), '', {
          distinguishCancelAndClose: true,
          confirmButtonText: _this.$t('是'),
          cancelButtonText: _this.$t('否'),
          type: 'warning'
        }).then(() => {
          isShowBarCode = 1
        }).catch((action) => {
          if (action === 'cancel') {
            isShowBarCode = 2
          } else {
            throw new Error('err')
          }
        })
      }
      const params = { ids: newArr, printType: type, isVip: true, language, isShowBarCode } // 添加language
      const res = await printOrders(params)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        // settlementName 到付现结 freight
        this.isCheckedAll = false
        setTimeout(() => {
          this.searchChange()
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return res.data
      } else {
        this.$refs['printOrder'].keyBtn = false
        res.msg && this.$message.error(this.$lang(res.msg))
        return false
      }
      // if (res.type === 'application/pdf') {
      //   window.console.log('application/pdf')
      //   this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
      //   // settlementName 到付现结 freight
      //   this.isCheckedAll = false
      //   setTimeout(() => {
      //     this.searchChange()
      //     // 更新库存面单
      //     if (this.exportStatus !== 'already_print') {
      //       this.UPDATE_PRINT_STOCK(true)
      //     }
      //   }, 1100)
      //   return res
      // } else if (res.type === 'application/json') {
      //   const reader = new FileReader()
      //   reader.readAsText(res)
      //   reader.onload = (event) => {
      //     const msg = JSON.parse(reader.result).msg || '' // 错误信息
      //     this.$message.error(this.$lang(msg))
      //   }
      //   this.$refs['printOrder'].keyBtn = false
      //   return false
      // }
      // } else {
      //   this.$refs['printOrder'].keyBtn = false
      //   return false
      // }
    },
    // 获取子账号
    async getFindChildAccount() {
      const { code, data, msg } = await findChildAccount()
      if (code === RESPONSE_SUCCESS) {
        this.findChildAccountList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 更新面单库存(获取用户信息)
    async getUserInfo() {
      const { code, data, msg } = await UserDetail({ id: this.userInfo.id })
      if (code === RESPONSE_SUCCESS) {
        this.SET_USER({ ...this.userInfo, ...data }) // 更新vuex的用户数据
      } else {
        this.$message.error(msg)
      }
    },
    // 删除订单
    async batchDelOrder() {
      const ids = []
      const openApi = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusName === '已取消') {
          ids.push(item.id)
        }
        if (item.orderSourceName !== 'VIP') {
          openApi.push(item.id)
        }
      })
      console.log(openApi)
      if (openApi.length > 0) {
        this.$message.warning(this.$lang('非VIP渠道禁止操作'))
        return
      }
      if (ids.length <= 0) {
        this.$message.warning(this.$lang('没有可删除的订单'))
        return
      }
      this.$confirm(
        `
      <div class="comfirm-wrap">
        <i class="el-icon-warning"></i>
        <h3 class="comfirm-hd">${this.$lang('删除订单')}</h3>
      </div>
      <p class="comfirm-tit">${this.$lang('你确定要删除已选中的订单吗？')}</p>
      `,
        '',
        {
          confirmButtonText: this.$lang('确定'),
          cancelButtonText: this.$lang('取消'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          customClass: 'comfirm-box',
        }
      )
        .then(async () => {
          this.loading = true
          const { code, msg } = await orderBatchDelete(ids)
          this.loading = false
          if (code === RESPONSE_SUCCESS) {
            this.$message.success(this.$lang('删除成功'))
            this.searchChange()
          } else {
            this.$message.error(this.$lang(msg))
          }
        })
        .catch(_ => {
        })
    },
    // 取消订单
    batchCancelOrder() {
      const ids = []
      const openApi = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusName === '待打印' || item.orderStatusName === '已打印') {
          ids.push(item.id)
        }
        if (item.orderSourceName !== 'VIP') {
          openApi.push(item.id)
        }
      })
      console.log(openApi, openApi.length)
      if (openApi.length > 0) {
        this.$message.warning(this.$lang('非VIP渠道禁止操作'))
        return
      }
      if (ids.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.selectId = ids.join(',')
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 合单
    mergeOrder() {
      const arr1 = []
      const arr2 = []
      const selection = this.multipleSelection.filter(item => {
        if (item.orderStatusName !== '待打印') arr1.push(item)
        if (item.packageTotalWeight > 30) arr2.push(item)
        return item.orderStatusName === '待打印' && item.packageTotalWeight <= 30
      })
      if (arr2.length > 0) {
        this.$message.warning(this.$lang('单票寄件重量不能大于30kg，无法合单，请重新选择！'))
        return
      }
      if (selection.length < 2) {
        if (arr1.length > 0) {
          this.$message.warning(this.$lang('只有待打印订单才可以合单！'))
          return
        }
      }
      const map = {}
      const keys = ['senderName', 'senderMobilePhone', 'senderProvinceName', 'senderCityName', 'senderAreaName', 'senderDetailedAddress',
        'receiverName', 'receiverMobilePhone', 'receiverProvinceName', 'receiverCityName', 'receiverAreaName', 'receiverDetailedAddress',
      ]
      const keysFn = (item) => keys.map(key => item[key].toString()).join('')
      selection.forEach(item => {
        const key = keysFn(item)
        if (!map[key]) {
          map[key] = [item]
        } else {
          map[key].push(item)
        }
      })
      for (const key in map) {
        if (map[key].length > 1) {
          this.mergeList.push(map[key])
        }
      }
      if (this.mergeList.length < 1) return this.$message.warning(this.$lang('未查询到可以合并的订单'))
      this.isShowMerge = true
    },
    // 关闭合单弹窗
    closeMerge(isReload) {
      this.isShowMerge = false
      this.mergeList = []
      if (isReload) {
        this.searchChange()
      }
    },
    // 面单打印
    openMenu(e, sub) {
      this.$rightMenu.open({
        target: e,
        menuList: [
          {
            val: this.$lang('两联面单'),
            abled: true,
            value: 2,
          },
          {
            val: this.$lang('一联面单'),
            abled: true,
            value: 1,
          },
        ],
        posobj: {
          left: e.clientX,
          top: e.clientY,
        },
        callback: ({ value }) => {
          this.print(value)
          this.$rightMenu.close()
        },
      })
    },
    // 选择日期
    selectDate() {
      if (!this.searchParam.date) {
        return
      }
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startdate = start
      this.searchParam.enddate = end
    },
    // 查询
    async searchChange(params) {
      const { startdate, enddate, waybillIds, ids, customerOrderIds, thirdPartyWaybillIds } = this.searchParam
      const homeQuery = {
        orderStatusCode: this.tabActive,
        startTime: startdate,
        endTime: enddate,
        date: [startdate, enddate],
      }
      sessionStorage.setItem('homeQuery', JSON.stringify(homeQuery))
      const space = 60 * 24 * 3600 * 1000
      const startTime = new Date(startdate).getTime()
      const endTime = new Date(enddate).getTime()
      if ((endTime - startTime) > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于60天'))
        return
      }
      // this.searchParam.tabTypeCode = this.menuItems.length > 0 ? this.menuItems[this.activeIndex].orderStatusCode : ''
      // 处理订单编号
      if (ids && ids.length !== 0) {
        if (ids.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      // this.searchParam.customerOrderIds = this.searchParam.customerOrderIds.length > 0 && !this.searchParam.customerOrderIds[0] ? [] : this.searchParam.customerOrderIds
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条运单'))
        }
      }
      // 处理客户订单号
      if (customerOrderIds && customerOrderIds.length !== 0) {
        if (customerOrderIds.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条客户订单'))
        }
      }
      // 三方运单号200条限制
      if (thirdPartyWaybillIds && thirdPartyWaybillIds.length !== 0) {
        if (thirdPartyWaybillIds.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条三方运单号'))
        }
      }
      // 列表查询
      this.searchFun(1)
      // 列表总数查询
      this.orderTotalGroup(this.searchParam)
      this.multipleSelection = []
    },

    /**
     * 数字格式转换成千分位
     *@param{Object}num
     */
    commafy(val) {
      val = parseFloat(val).toLocaleString()
      // if (val.indexOf('.') === -1) {
      //   val = val + '.00'
      // } else if (val.charAt(val.indexOf('.') === val.length - 2)) {
      //   val = val + '0'
      // }
      return val
    },

    getParams() {
      const { tabTypeCode, ids } = this.searchParam
      const newIds = ids && ids.length >= 1 && ids[0] === '' ? [] : ids
      const searchParam = Object.assign({}, this.searchParam)
      searchParam.ids = newIds
      searchParam.tabTypeCode === '0' ? '' : tabTypeCode
      searchParam.isVip = true
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip', 'expressTypeCodeList']
      Object.keys(searchParam).forEach(item => {
        if (!arr.includes(item)) {
          if (searchParam[item] instanceof Array && searchParam[item][0]) {
            delete searchParam.startdate
            delete searchParam.enddate
          } else if (typeof searchParam[item] === 'string' && searchParam[item]) {
            delete searchParam.startdate
            delete searchParam.enddate
          }
        }
      })
      return searchParam
    },
    handleSelect(key) {
      const menuItems = this.menuItems
      this.searchParam.tabTypeCode = menuItems[key].orderStatusCode
      this.exportStatus = menuItems[key].orderStatusCode
      this.activeIndex = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.isCheckedAll = false
      // 重置表格滚动条置顶
      this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      this.searchFun()
      // 清空选中数据
      this.multipleSelection = []
      this.autoPrint = false
      // 列表总数查询
      this.orderTotalGroup(this.searchParam)
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
    cancelFn(row) {
      this.selectId = row.id
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 取消成功
    cancelSuccess() {
      this.multipleSelection = []
      this.isCheckedAll = false
      setTimeout(() => {
        this.orderTotalGroup(this.searchParam)
        this.searchFun()
      }, 1000)
    },
    // 删除成功回调
    afterDelSuccess() {
      this.cancelSuccess()
    },
    // 打开导出弹框
    async exportOpen() {
      // 处理订单编号
      const { ids, waybillIds } = this.searchParam
      if (ids && ids.length !== 0) {
        if (ids.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条运单'))
        }
      }

      if (this.multipleSelection.length <= 0) {
        this.exportLoading = true
        await this.orderTotalGroup(this.searchParam)
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.menuItems[this.activeIndex].total || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.orderOptions = [...this.$refs.table.dynamicColumns.filter(item => item.show)]
      /**
       * @description 如果设置了 不显示参考运费 删除参考运费
       */
      if (this.userInfo.freightStatus === 0) {
        const chooseIndex = this.orderOptions.findIndex(item => item.name === '参考运费')
        // 删除参考运费选项
        this.orderOptions.splice(chooseIndex, 1)
      }

      // this.updateOutExcel(this.currentKey)
      // this.exportVisible = true
      const exportData = {
        // startDate: this.searchParam.startdate,
        // endDate: this.searchParam.enddate,
        exportStatus: this.exportStatus,
        exportType: this.exportType, // 1：订单； 2：运单
      }
      this.exportData = exportData
      this.exportFn()
    },
    // 关闭导出弹框
    // exportClose(val) {
    //   this.exportVisible = val
    // },
    // 导出-获取参数
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      const len = this.multipleSelection && this.multipleSelection.length || 0
      if (len) ids = this.multipleSelection.map(item => item.id)
      // 处理导出表格的属性字段
      this.orderOptions.forEach(item => {
        sort.push(item.prop)
        columnNames.push(item.name)
      })
      let params = { sort, columnNames, orderStatusCode: this.exportStatus, tabTypeCode: this.exportStatus, isVip: true }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip']
      Object.keys(params).forEach(item => {
        if (!arr.includes(item)) {
          if (params[item] instanceof Array && params[item][0]) {
            delete params.startdate
            delete params.enddate
          } else if (typeof params[item] === 'string' && params[item]) {
            delete params.startdate
            delete params.enddate
          }
        }
      })
      return params
    },
    // 导出数据
    async exportFn(bool, data, dataParams) {
      // this.exportVisible = bool
      // this.columnList = data
      // this.excelParams = dataParams
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportOrder()
    },
    async asyExportOrder() {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 更新导出参数配置
    updateOutExcel(key = 0) {
      // cityOptions
      const inputTime = {
        key: 'inputTime',
        prop: 'inputTime',
        name: this.$lang('下单时间'),
      }
      const pickTime = {
        key: 'pickTime',
        prop: 'pickTime',
        name: this.$lang('取件时间'),
      }
      const cancelTime = {
        key: 'cancelTime',
        prop: 'cancelTime',
        name: this.$lang('取消时间'),
      }
      //   const printTime = {
      // key: 'printTime',
      // name: '打印时间',
      //   }
      this.orderOptions.push(inputTime, pickTime, cancelTime)
    },
    // 获取tabs
    async orderTotalGroup(reqData) { // 运单状态数据统计
      const { code, data } = await orderTotalGroup(this.getParams())
      if (code === RESPONSE_SUCCESS) this.menuItems = data
    },
    openFile(blob, fileName) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.target = '_blank'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
    },
    dataURLtoBlob(data) {
      const bstr = atob(data)
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: 'application/pdf' })
    },
    // 查看
    rowView(row) {
      this.selectId = row.id
      this.viewDialogVisible = true
      // 获取查看详情
      this.viewFun(row)
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      if (row.orderSourceCode === 'D21') {
        if (row.goodsJson && row.goodsJson.length) {
          const temp = row.goodsJson.map(v => v.name + `（${this.$lang('数量')}：` + v.quantity + '，SKU：' + v.sku + '）')
          row.customerPickInfo = temp.join(';')
        }
      }
      return { ...row }
    },
    // close:关闭；delWaybill删除运单  ； cancelOrder:取消订单； ediOrder:编辑订单 delOrder:删除订单；
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
      switch (val.type) {
        case 'cancelOrder':
          this.$refs.cancelOrder.dialogTableVisible = true
          break
        case 'ediOrder':
          this.editDialogVisible = true
          break
        case 'delOrder':
          const item = {
            orderId: val.rowData.id,
          }
          this.rowDel(item)
          break
      }
    },
    // 判断是否含有可调度的订单
    orderYesOrNo(valList) {
      const flag = false
      // if (valList.length > 0) {
      //   valList.filter(item => {
      //     if (item.isOrders === 1) {
      //       return (flag = true)
      //     }
      //   })
      // }
      return flag
    },
    // 编辑取消
    editClose() {
      this.handleClose()
    },
    // 编辑保存
    editSave(data) {
      data = { ...data }
      this.$refs['editOrder'].$refs['orderForm'].validate(async valid => {
        if (valid) {
          const formData = Object.assign(data, { from: 8, packageChargeWeight: data.packageTotalWeight })
          delete formData.terminalDispatchCode
          formData.codMoney = !formData.codMoney ? 0 : formData.codMoney
          this.$refs['editOrder'].keyBtn = true
          // 编辑保存
          this.submitForm('reqUpdate', formData)
        } else {
          return false
        }
      })
    },
    async submitForm(reqType, updateParams) {
      try {
        let res = {}
        this.keyBtn = true
        res = await this.COM_HTTP[reqType](updateParams)
        this.keyBtn = false
        if (res.code === RESPONSE_SUCCESS) {
          this.handleClose()
          setTimeout(() => {
            this.searchFun()
          }, 300)
          this.$message.success(this.$lang('保存成功'))
        } else {
          this.$refs['editOrder'].keyBtn = false
          this.$message.warning(res.msg)
        }
      } catch (err) {
        this.$refs['editOrder'].keyBtn = false
      }
    },
    // 表单关闭（关闭弹窗）
    beforehandleClose() {
      this.$refs['editOrder'].keyBtn = false
    },
    // 重置编辑表单
    clearFormItem() {
      this.$refs['editOrder'].$refs['orderForm'].resetFields()
    },
    printDialogClode() {
      this.printTableVisible = false
    },
    // 件数事件
    // getSubOrder(row) {
    //   if (row.orderStatusName === '待打印' || row.orderStatusName === '已打印') return this.$message.warning('只有待打印/已打印的订单才能打印！')
    //   if (row.printsNumber < 1) return this.$message.warning('请先打印主订单后再打印子订单！')
    //   this.selectId = row.id
    //   this.printTableVisible = true
    // },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        ids: [],
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        waybillIds: [],
        customerOrderIds: [],
      }
      var qianfenwei = this.commafy('10000')
      console.log('qianfenwei', qianfenwei)
      // alert(qianfenwei)
      this.$refs.BaseInputTag1.clearFn()
      this.$refs.BaseInputTag2.clearFn()
      this.$refs.BaseInputTag3.clearFn()
      this.$refs.BaseInputTag4.clearFn()
    },
    // 全选
    handleSelectAll1(arr) {
      const val = arr.filter(item => {
        return this.permission('CANCEL', item)
      })
      if (!this.orderYesOrNo(val)) {
        this.multipleSelection = val
        this.originSelectionAll = [...val]
        if (val.length) {
          this.isCheckedAll = true
        } else {
          this.isCheckedAll = false
        }
      }
    },
    // 单个选中
    handleSelectionChange(val, currentRow) {
      if (!this.orderYesOrNo(val)) {
        // 检测当前行的选中状态
        const isChecked = val.some(item => item.id === currentRow.id)
        if (this.isCheckedAll) {
          if (!isChecked) {
            this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.id]
          } else {
            this.isSinleSelection = this.isSinleSelection.filter(item => item !== currentRow.id)
          }
          this.multipleSelection = this.originSelectionAll.filter(item => !this.isSinleSelection.includes(item.id))
        } else {
          this.multipleSelection = val
        }
      }
    },
    changeTab(index, orderStatusCode) {
      this.tabActive = orderStatusCode
      this.handleSelect(index)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    handleCompositionEnd(e) {
      console.log(e)
    },
    // 单页统计数据
    summaryMethod(param) {
      const { columns } = param
      const columnTypeList = [
        'codMoney'
      ]
      const sums = []
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$lang('总计')
          } else if (columnTypeList.includes(column.property)) {
            sums[index] = this.totalCodMoney
          } else {
            sums[index] = this.$lang('--')
          }
        })
      }
      return sums
    },
    // 搜索成功之后
    searchAfterFun() {
      if (this.tabActive === 'already_print' || this.tabActive === 'already_pick') {
        this.$nextTick(() => {
          this.$refs.table.$refs.table.doLayout()
        })
      }
    }
  },
}
</script>
<style lang="scss" scoped>
body {
  ::v-deep .el-tooltip__popper {
    width: 550px !important;
    // z-index: 9999;
  }
}

.remark-style {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.el-form-item {
  margin-bottom: 0;
}

.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}

.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}

input {
  font-size: 12px !important;
}

.order {
  .order-top {
    padding: 16px 24px;

    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
  }

  .order-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }

  .search-btns {
    margin-bottom: 10px;
  }

  .tabs-nav {
    // margin: 5px 0 9px;
    .tabs-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: .1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;

      &:first-of-type {
        margin-left: 0px
      }

      i {
        margin-right: 8px;
        color: #666;
      }

      &.active {
        background: #fff;
        color: #e60012;

        i {
          color: #e60012;;
        }
      }
    }

    .tabs-nav-item-count {
      display: inline-block;
      width: 35px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>
<style lang="scss">
.vipsBox {
  .el-input__prefix, .el-input__suffix {
    top: -4px;
  }
}

.order .order-top .el-input__inner {
  margin-bottom: 10px;
}

.expressTypeCodeList-input {
  .el-input__inner, input {
    max-height: 34px;
  }
  .el-select__tags {
    height: 30px;
  }
  .el-tag {
    max-width: 83px;
    overflow: hidden;
  }
}
</style>
